import { render, staticRenderFns } from "./fileMaxSize-editor.vue?vue&type=template&id=6aaf7d9c&scoped=true&"
import script from "./fileMaxSize-editor.vue?vue&type=script&lang=js&"
export * from "./fileMaxSize-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaf7d9c",
  null
  
)

export default component.exports